// extracted by mini-css-extract-plugin
export var link = "article_card-module--link--38N8k";
export var text = "article_card-module--text--2sGtn";
export var title = "article_card-module--title--1flzo";
export var summary = "article_card-module--summary--1MZZv";
export var badge = "article_card-module--badge--1qqdr";
export var videoIcon = "article_card-module--videoIcon--1HoCk";
export var partnerLink = "article_card-module--partnerLink--3ltOh";
export var partnerImg = "article_card-module--partnerImg--3ERfN";
export var publicationDate = "article_card-module--publicationDate--3oize";